import { Injectable } from "@angular/core";
import type { Observable } from 'rxjs';
import { User } from "../planvue-api";
import { UserUpdate } from "../planvue-api/models/UserUpdate";
import { UserService as BaseUserService } from "../planvue-api/services/UserService";

@Injectable({
  providedIn: 'root',
})
export class UserService extends BaseUserService {
	
	/**
	 * Patch User
	 * @param userId 
	 * @param requestBody 
	 * @returns User Successful Response
	 * @throws ApiError
	 */
	public override  patchUser(
userId: number,
requestBody: Partial<UserUpdate>,
): Observable<User> {
				return this.httpRequest.request({
			method: 'PATCH',
			url: '/user/{user_id}',
			path: {
				user_id: userId
			},
			body: requestBody,
			mediaType: 'application/json',
			errors: {
				403: `No Permission`,
				404: `Record Not Found`,
				409: `Record Already Exists`,
				422: `Validation Error`,
				500: `Internal Server Error`,
				502: `API Service is not currently online?`,
			},
		});
	}
}